import React from 'react';

import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getActiveProduct } from '../../../store/products/selectors';
import localization from '../../../shared/strings';
import ButtonLoader from './ButtonLoader';
import useSyncToChannel from './useSyncToChannel';
import styles from './styles.module.scss';

const ConnectChannelSection = ({ productId, variantId: variantIdProp }) => {
  const location = useLocation();
  const variantId = variantIdProp ?? getActiveProduct(location)?.variantId;
  const { busyLoadingText, hasConnectedChannels, isBusy } = useSyncToChannel({
    productId,
    variantId,
  });
  const text = hasConnectedChannels
    ? localization.PRODUCT_INFO.PREPARE_CHANNEL_VERSION
    : localization.PRODUCT_INFO.TO_PUBLISH_A_PRODUCT_TEXT;

  return (
    <div className="d-flex ai-center jc-sb p-t-5 p-b-5 w-100">
      <p className="f-s-14 f-w-4 labelInputText">{text}</p>
      <If condition={isBusy}>
        <span className={styles.busyStatus}>
          <ButtonLoader />
          <If condition={busyLoadingText}>
            <span>{busyLoadingText}</span>
          </If>
        </span>
      </If>
    </div>
  );
};

ConnectChannelSection.propTypes = {
  productId: PropTypes.string.isRequired,
  variantId: PropTypes.string,
};

ConnectChannelSection.defaultProps = {
  variantId: null,
};

export default ConnectChannelSection;
